// tenant/TenantApp.tsx
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { TenantUserInfoProvider } from '../context/userInfoProvider';
import TenantNavbar from './TenantNavbar';
import TenantHomePage from './HomePages/TenantHomePage';
import ViewOrderPage from './HomePages/ViewOrderPage';
import HomeInventoryPage from './HomePages/HomeInventory';
import StorageInventoryPage from './HomePages/StorageInventory';
import TenantNewAppointmentPage from './HomePages/NewAppointmentPage';
import TenantNewDeliveryPage from './HomePages/NewDeliveryPage';
import TenantNewPickupPage from './HomePages/NewPickupPage';
import TenantScheduleAppointmentPage from './HomePages/ScheduleAppointmentPage';
import TenantConfirmAddressPage from './HomePages/ConfirmAddressPage';
import TenantReviewOrderPage from './HomePages/ReviewOrderPage';
import TenantOrderConfirmationPage from './HomePages/OrderConfirmationPage';

import TenantOrdersPage from './OrderPages/TenantOrdersPage';
import TenantOrderDetailPage from './OrderPages/TenantOrderDetailPage';

import TenantMenuPage from './MenuPages/TenantMenuPage';
import TenantAccountPage from './MenuPages/TenantAccountPage';
import TenantPlanPage from './MenuPages/TenantPlanPage';
import TenantFaqPage from './MenuPages/TenantFAQPage';
import TenantBillingPage from './MenuPages/TenantBillingPage';

import ContractPage from './LegalPages.tsx/ContractPage';
import PrivacyPolicyPage from './LegalPages.tsx/PrivacyPage';
import TermsPage from './LegalPages.tsx/TermsPage';

const TenantApp: React.FC = () => {
  return (
    <TenantUserInfoProvider>
      <div style={{ minHeight: '100vh', backgroundColor: '#261136' }}>
        <TenantNavbar />
        <div>
          <Switch>
            
            <Route exact path="/tenant">
              <Redirect to="/tenant/home" />
            </Route>

            <Route path="/tenant/home/homeinventory">
              <HomeInventoryPage />
            </Route>

            <Route path="/tenant/home/storageinventory">
              <StorageInventoryPage />
            </Route>

            <Route path="/tenant/home/:orderId">
              <ViewOrderPage />
            </Route>

            <Route path="/tenant/home">
              <TenantHomePage />
            </Route>

            <Route path="/tenant/orders/:id">
              <TenantOrderDetailPage />
            </Route>

             <Route path="/tenant/orders">
              <TenantOrdersPage />
            </Route>

            <Route path="/tenant/account">
              <TenantAccountPage />
            </Route>

            <Route path="/tenant/plan">
              <TenantPlanPage />
            </Route>

            <Route path="/tenant/faq">
              <TenantFaqPage />
            </Route>

            <Route path="/tenant/billing">
              <TenantBillingPage />
            </Route>

            <Route path="/tenant/privacy">
              <PrivacyPolicyPage />
            </Route>

            <Route path="/tenant/contract">
              <ContractPage />
            </Route>

            <Route path="/tenant/terms">
              <TermsPage />
            </Route>

            <Route path="/tenant/menu">
              <TenantMenuPage />
            </Route>

            <Route path="/tenant/neworder/confirmation">
              <TenantOrderConfirmationPage />
            </Route>

            <Route path="/tenant/neworder/review">
              <TenantReviewOrderPage />
            </Route>

            <Route path="/tenant/neworder/address">
              <TenantConfirmAddressPage />
            </Route>

            <Route path="/tenant/neworder/schedule">
              <TenantScheduleAppointmentPage />
            </Route>

            <Route path="/tenant/newpickup">
              <TenantNewPickupPage />
            </Route>

            <Route path="/tenant/newdelivery">
              <TenantNewDeliveryPage />
            </Route>

            <Route path="/tenant/newappointment">
              <TenantNewAppointmentPage />
            </Route>

            <Route path="/tenant/newappointment">
              <TenantNewAppointmentPage />
            </Route>

            <Route path="*">
              <Redirect to="/tenant/home" />
            </Route>
          </Switch>
        </div>
      </div>
    </TenantUserInfoProvider>
  );
};

export default TenantApp;
